import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { MatSelectChange } from '@angular/material/select';

import { PraxisService } from './service/praxis.service';

import { Token } from '../../../interface/Token';
import { Descripcion, Especialidades } from './interface/Especialidades';
import { SumaAsegurada } from './interface/SumaAsegurada';
import { Localidades } from "./interface/Localidades";
import { Provincias } from './interface/Provincias';
import { TipoIva } from './interface/TipoIva';
import { Matriculas } from './interface/matriculas';
import { rootService } from '../../../service/rootService.service';

@Component({
    selector: 'app-praxis',
    templateUrl: './praxis.component.html',
    styleUrl: './praxis.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PraxisComponent implements OnInit {

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  isLinear = true;
  documento_selected: string = '';
  selectedProvincia: string | null = null;
  numeros: number[] = [];
  uuid: any = '';

  checkedJefe = false;
  checkedDirector = false;


  public token: string = '';
  public especialidades: Especialidades[] = [];
  public vet_sub: Descripcion[] = [];
  public provincias: Provincias[] = [];
  public localidades: Localidades[] = [];
  public iva: TipoIva[] = [];
  public matriculas: Matriculas[] = [];

  public especialidadesControl = new FormControl('');
  public codPostalControl = new FormControl('');
  public selectedEspecialidad?: Especialidades;

  public sa?: SumaAsegurada;

  constructor (
              private praxisService: PraxisService,
              private rootService: rootService,
              private _formBuilder: FormBuilder,
              private router: Router,
              private route: ActivatedRoute
              ) {
                this.firstFormGroup = this._formBuilder.group({
                  especialidadControl: ['', [Validators.required]],
                  tipoAnimalesControl: ['81105', Validators.required],
                  tipoMatriculaControl: ['', [Validators.required]],
                  matriculaControl: ['', Validators.required],
                  tituloControl: ['', Validators.required],
                  saControl: ['', Validators.required],
                });
                this.secondFormGroup = this._formBuilder.group({
                  apellidoControl: ['', Validators.required],
                  nombreControl: ['', Validators.required],
                  ivaControl: ['', Validators.required],
                  cpControl:['', Validators.required],
                  localidadControl: ['', Validators.required],
                  provinciaControl: ['', Validators.required],
                  celularControl: ['', Validators.required],
                  emailControl: ['', Validators.required]
                })
              }

  ngOnInit(): void {
    /*
    this.route.paramMap.subscribe(params => {
      this.uuid = params.get('uuid');

      localStorage.setItem('uuid', this.uuid);
      //this.ruta.navigate([`/${this.uuid}/cotizador/ramos`]);
      //console.log('ID desde la URL:', this.uuid);
      // Ahora puedes usar el parámetro 'id' para realizar acciones adicionales
    });
    */
   this.token = localStorage.getItem('token') || '';

   this.praxisService.getProvincias(this.token)
                     .subscribe(
                       (datos) => {
                         this.provincias = datos;
                       }
                     )

                     this.praxisService.getIva(this.token, '', '3')
                     .subscribe(
                       (datos) => {
                         this.iva = datos;
                       }
                     )
   this.cargar_especialidades();
   this.consultar_matriculas();



   }


   onToggleChange(tipo: string, checked: boolean) {
    if (tipo === 'jefe') {
      this.checkedJefe = checked;
      localStorage.setItem('jefe', checked ? '1' : '0');
    } else if (tipo === 'director') {
      this.checkedDirector = checked;
      localStorage.setItem('director', checked ? '1' : '0');
    }
  }

   formatLabel(value: number): string {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'k';
    }

    return `${value}`;
  }


   public cargar_especialidades(){
    const value: string = this.especialidadesControl.value || '';

    this.praxisService.getEspecialidades(this.token, value)
                      .subscribe(
                        (datos: Especialidades[]) => {
                          this.especialidades = datos;
                        }
                      )
   }

   onOptionSelected( event: MatSelectChange ): void {

    const especialidad: Especialidades = event.value;
    this.vet_sub = [];
    this.sa = undefined;

    if (event.value === '0'){
      this.veterinarios();
    } else {

      this.sumaasegurada(event.value);
    }

  }


  cambioVet(event: MatSelectChange): void {
    // `event.value` contiene el valor seleccionado por el usuario
    const valorSeleccionado = event.value;
    this.sumaasegurada_veterinarios(valorSeleccionado);

    // Realiza acciones adicionales según sea necesario
    // Por ejemplo, actualiza otros controles del formulario o llama a servicios
  }



  public veterinarios(){
    this.praxisService.getVeterinarios(this.token)
                      .subscribe(
                        (datos) => {
                          this.vet_sub = [...datos];
                        }
                      )
  }

  public sumaasegurada($categoria: string){
    this.praxisService.getSumaAsegurada(this.token, $categoria)
                      .subscribe(
                        (datos) => {
                          this.sa = datos;
                          this.generarNumeros(parseInt(this.sa.categorias_praxis_sa_minima), parseInt(this.sa.categorias_praxis_sa_maxima));
                        }
                      )
  }


  public consultar_matriculas(){
    this.praxisService.getMatriculas(this.token)
                      .subscribe(
                        (datos) => {
                          this.matriculas = [...datos];
                        }
                      )

  }

  public sumaasegurada_veterinarios($tipo_veterinario: string){
    this.praxisService.getSumaAsegurada_veterinario(this.token, $tipo_veterinario)
                      .subscribe(
                        (datos) => {
                          this.sa = datos;
                          this.generarNumeros(parseInt(this.sa.categorias_praxis_sa_minima), parseInt(this.sa.categorias_praxis_sa_maxima));
                        }
                      )
  }


  generarNumeros(minimo: number, maximo: number) {

    this.numeros = [];
    for (let i = minimo; i <= maximo; i += 1000000) {
      this.numeros.push(i);
    }
  }


  buscar_cp(){

    const cod_postal = this.secondFormGroup.controls['cpControl'].value || '';

    if (cod_postal.length >= 4){
      this.praxisService.getLocalidades(this.token, cod_postal)
                          .subscribe(
                            (datos) => {
                              this.localidades = [...datos];
                              //this.cdr.detectChanges();
                              //this.selectLocalidades.open();
                            }
                          )
                          }
  }

  seleccionar_provincia(event: any): void{
    const selectedLocalidad = event.value;
    // Busca la provincia relacionada con la localidad seleccionada
    const localidad = this.localidades.find(l => l.Localidad === selectedLocalidad);
    if (localidad) {
      // Asigna el valor de provincia correspondiente a la localidad seleccionada
      this.selectedProvincia = localidad.Provincia;
    }
  }


  cotizar(){
    localStorage.setItem('ramo', '30');
    localStorage.setItem('solicitar', 'false');
    localStorage.setItem('conducto_pago', '4');
    localStorage.setItem('iibb', '0');
    localStorage.setItem('iva', this.secondFormGroup.controls['ivaControl'].value);
    localStorage.setItem('tipo_persona', 'F');
    localStorage.setItem('tipo_matricula', this.firstFormGroup.controls['tipoMatriculaControl'].value);
    localStorage.setItem('matricula', this.firstFormGroup.controls['matriculaControl'].value);
    if (this.firstFormGroup.controls['especialidadControl'].value != '0'){
      localStorage.setItem('codigo_especialidad', this.firstFormGroup.controls['especialidadControl'].value);
    } else {
      localStorage.setItem('codigo_especialidad', this.firstFormGroup.controls['tipoAnimalesControl'].value);
    }
    localStorage.setItem('titulo', this.firstFormGroup.controls['tituloControl'].value);
    localStorage.setItem('suma_asegurada', this.firstFormGroup.controls['saControl'].value);
    localStorage.setItem('apellido', this.secondFormGroup.controls['apellidoControl'].value);
    localStorage.setItem('nombre', this.secondFormGroup.controls['nombreControl'].value);
    localStorage.setItem('cp', this.secondFormGroup.controls['cpControl'].value);
    localStorage.setItem('tipo_documento', '1');
    localStorage.setItem('celular', this.secondFormGroup.controls['celularControl'].value);
    localStorage.setItem('email', this.secondFormGroup.controls['emailControl'].value);
    localStorage.setItem('jefe', (this.checkedJefe == true) ? '1' : '0');
    localStorage.setItem('director', (this.checkedDirector == true) ? '1' : '0');
    this.router.navigate(['cotizacion'], { relativeTo: this.route });
  }
}
